/**
 * Erststart-Befuellung.
 *
 * Laeuft genau einmal: die Markierung liegt in `meta`, nicht in einer
 * Zeilenzahl-Pruefung - sonst wuerde ein absichtlich leergeraeumtes System beim
 * naechsten Start wieder Beispieldaten bekommen.
 */
import { db } from '@/db/schema';
import { getMeta, setMeta, META_SEEDED } from '@/db/repositories/meta';

export async function seedIfEmpty(): Promise<void> {
  if (await getMeta(META_SEEDED, false)) return;

  // Die Bereiche selbst legt festeBereicheSicherstellen() an (BE-02) - bei jedem Start.
  await setMeta(META_SEEDED, true);
}

/**
 * Setzt die Seed-Markierung zurueck. Wird nach einem Import aufgerufen: die
 * importierten Daten sind der neue Stand, und ein erneutes Seeding wuerde
 * doppelte Bereiche erzeugen.
 */
export async function markSeeded(): Promise<void> {
  await setMeta(META_SEEDED, true);
}

/** Nur fuer Tests: kompletter Reset aller Nutzdaten. */
export async function clearAllData(): Promise<void> {
  await db.transaction('rw', db.tables, async () => {
    await Promise.all(db.tables.map((t) => t.clear()));
  });
}
